import React from 'react';
import {
  Row, Col, Form, Input,
} from 'antd';
import CurrencyInput from 'react-currency-input';
import PropTypes from 'prop-types';
import { getUserType } from '../../../../../utils/users';
import './DetailsEdit.scss';

const DetailsEdit = (props) => {
  const {
    initialValuesObject,
    edit,
  } = props;

  const getValorUnitario = (_initialValuesObject) => {
    if (_initialValuesObject?.['GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-VALOR_UNITARIO']) {
      return _initialValuesObject['GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-VALOR_UNITARIO'].replaceAll('.', ',');
    }
    return '0,00';
  };
  const getValorTotal = (_initialValuesObject) => {
    if (_initialValuesObject?.['GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-VALOR_TOTAL']) {
      return initialValuesObject['GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-VALOR_TOTAL'].replaceAll('.', ',');
    }
    return '0,00';
  };

  const validatorValorUnitario = (rule, value) => {
    if (value < 0) {
      return Promise.reject(new Error('Deve ser um numero maior que zero'));
    }

    return Promise.resolve();
  };

  return (
    <div>
      {
        getUserType() === 'COOPERCITRUS'
          ? (
            <>
              <Row gutter={[24, 24]}>
                <Col xs={{ span: 24 }}>
                  <hr />
                  <p className="ClassificacaoSoloAmbienteProducaoDetails__SessionTitle">Orçamento</p>
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
              >
                <Col
                  xs={{ span: 24 }}
                >
                  <Form.Item
                    label={<span className="field-title-text">Valor unitário</span>}
                    name="GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-VALOR_UNITARIO"
                    rules={[
                      {
                        validator: validatorValorUnitario,
                      },
                    ]}
                    initialValue={(getValorUnitario(initialValuesObject))}
                  >
                    <CurrencyInput
                      allowEmpty="true"
                      className="ant-input"
                      decimalSeparator=","
                      thousandSeparator="."
                      placeholder="0,00"
                      step={0.01}
                      min={0}
                      disabled={edit}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
              >
                <Col
                  xs={{ span: 24 }}
                >
                  <Form.Item
                    label={<span className="field-title-text">Valor total</span>}
                    name="GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-VALOR_TOTAL"
                    rules={[
                      {
                        validator: validatorValorUnitario,
                      },
                    ]}
                    initialValue={(getValorTotal(initialValuesObject))}
                  >
                    <CurrencyInput
                      allowEmpty="true"
                      className="ant-input"
                      decimalSeparator=","
                      thousandSeparator="."
                      placeholder="0,00"
                      step={0.01}
                      min={0}
                      disabled={edit}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
              >
                <Col
                  xs={{ span: 24 }}
                >
                  <Form.Item
                    label={<span className="field-title-text">Condição de pagamento</span>}
                    name="GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-CONDICAO_PAGAMENTO"
                    rules={[
                      { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                    ]}
                    initialValue={initialValuesObject?.['GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-CONDICAO_PAGAMENTO']}
                  >
                    <Input
                      style={{ width: '100%' }}
                      disabled={edit}
                      maxLength="255"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
              >
                <Col
                  xs={{ span: 24 }}
                >
                  <Form.Item
                    label={<span className="field-title-text">Forma de pagamento</span>}
                    name="GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-FORMA_PAGAMENTO"
                    rules={[
                      { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                    ]}
                    initialValue={initialValuesObject?.['GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-FORMA_PAGAMENTO']}
                  >
                    <Input
                      style={{ width: '100%' }}
                      disabled={edit}
                      maxLength="255"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
              >
                <Col
                  xs={{ span: 24 }}
                >
                  <Form.Item
                    label={<span className="field-title-text">Observações do orçamento</span>}
                    name="GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-OBSERVACOES"
                    rules={[
                      { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                    ]}
                    initialValue={initialValuesObject?.['GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-OBSERVACOES']}
                  >
                    <Input
                      style={{ width: '100%' }}
                      disabled={edit}
                      maxLength="255"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )
          : null
      }
    </div>
  );
};

DetailsEdit.propTypes = {
  initialValuesObject: PropTypes.shape({
    'GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-VALOR_UNITARIO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-VALOR_TOTAL': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-CONDICAO_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-FORMA_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-CLASSIFICACAO-SOLO-AMBIENTE-PRODUCAO-OBSERVACOES': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  edit: PropTypes.bool,
};

DetailsEdit.defaultProps = {};

export default DetailsEdit;
